import packageJson from '../package.json';
import Logger from 'js-logger';
console.info("Using %c" + packageJson.name + " %cv" + packageJson.version, 'font-style: italic;', 'font-weight: bold;');
Logger.useDefaults();
Logger.setLevel(Logger.WARN);
export * from './components';
export * from './containers';
export * from './hoc';
export * from './hooks';